var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v34H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.614 7.438 9.066 16.09A3 3 0 0 1 27.066 28H8.934a3 3 0 0 1-2.614-4.473l9.066-16.089a3 3 0 0 1 5.228 0z",
  fill: "#CDEBF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.473 6.297a3 3 0 0 1 1.14 1.141l9.067 16.09A3 3 0 0 1 27.066 28H8.934a3 3 0 0 1-2.614-4.473l9.066-16.089a3 3 0 0 1 4.087-1.14zM17.129 8.42 8.063 24.51A1 1 0 0 0 8.934 26h18.132a1 1 0 0 0 .871-1.49L18.871 8.42a1 1 0 0 0-1.742 0zm.876 13.08c.207 0 .403.04.59.12.187.08.347.187.48.32s.24.293.32.48c.08.187.12.383.12.59 0 .213-.04.412-.12.595a1.448 1.448 0 0 1-.8.79 1.538 1.538 0 0 1-.59.115 1.564 1.564 0 0 1-1.085-.43 1.422 1.422 0 0 1-.32-.475 1.527 1.527 0 0 1-.115-.595c0-.207.038-.403.115-.59a1.41 1.41 0 0 1 .32-.48c.137-.133.298-.24.485-.32.187-.08.387-.12.6-.12zm1.19-9.75-.33 8.36h-1.67l-.33-8.36h2.33z",
  fill: "#0481A0"
}))));
export default SvgAlertIcon;